<div class="container mt-4 mb-5">
  <div class="row g-4">
    <div
      class="flex flex-col items-center justify-center w-full"
      style="min-height: calc(100vh - 280px)"
      *ngIf="!isLoading && fieldsData.length == 0"
    >
      <app-no-data-view
        title="No Business Units Found"
        description="There are no business units matching your current filters or search."
        imagePath="./assets/media/icons/empty-bu-small.svg"
        imageHeight="64px"
      >
      </app-no-data-view>
    </div>
    <ng-container *ngIf="!isLoading && fieldsData.length > 0">
      <div class="col-md-3 col-sm-6 mb-6" *ngFor="let option of fieldsData">
        <div
          class="border border-gray-200 rounded-xl h-100 bg-white dark:bg-coal-500"
        >
          <div class="p-4 flex justify-between items-center">
            <!-- <i
              (click)="openEditModal(option)"
              class="ki-outline ki-notepad-edit text-gray-600 ms-2 cursor-pointer"
            ></i> -->
            <!-- STATUS -->

            <span
              class="badge badge-outline rounded-full text-gray-900 w-80px"
              [ngClass]="{
                'badge-success': option.status == 'Active',
                'badge-secondary': option.status == 'Inactive',
              }"
            >
              {{ option.status }}
            </span>

            <div
              class="relative top-1 right-4 z-[5]"
              [class.show]="isDropdownOpen(option._id)"
              [class.open-above]="shouldOpenAbove(option._id)"
            >
              <button
                class="ctt-menu-btn"
                (click)="toggleDropdown(option._id, $event)"
                [attr.data-id]="option._id"
              >
                <span></span><span></span><span></span>
              </button>

              <div
                *ngIf="isDropdownOpen(option._id)"
                class="ctt-dropdown"
                [class.ctt-dropdown-up]="shouldOpenAbove(option._id)"
              >
                <button
                  class="ctt-dropdown-item"
                  (click)="
                    openEditModal(option);
                    closeAllDropdowns();
                    $event.stopPropagation()
                  "
                >
                  {{ isWriteAccess ? "Edit" : "View" }}
                </button>
                <button
                  *ngIf="isWriteAccess"
                  class="ctt-dropdown-item"
                  (click)="
                    deleteBusinessUnit(option);
                    closeAllDropdowns();
                    $event.stopPropagation()
                  "
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
          <div class="p-4 text-start pt-0">
            <!-- NAME -->
            <h2
              class="font-semibold text-sm text-gray-900 leading-snug truncate"
              [title]="option.name"
            >
              {{ option.name.slice(0, 20)
              }}{{ option.name.length > 20 ? "..." : "" }}
            </h2>

            <!-- Description -->
            <p
              class="text-gray-800 text-sm mt-1 min-h-[40px] line-clamp-2"
              [ngClass]="{ 'flex items-start': !option.description }"
              [title]="option.description || '-'"
            >
              {{
                option.description
                  ? option.description.slice(0, 50) +
                    (option.description.length > 50 ? "..." : "")
                  : "-"
              }}
            </p>

            <!-- LOCATION -->
            <div class="flex flex-row text-gray-600 gap-1 items-start mt-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                class="flex-shrink-0"
              >
                <path
                  fill="currentColor"
                  d="M12 2c-4.4 0-8 3.6-8 8c0 5.4 7 11.5 7.3 11.8c.2.1.5.2.7.2s.5-.1.7-.2C13 21.5 20 15.4 20 10c0-4.4-3.6-8-8-8m0 17.7c-2.1-2-6-6.3-6-9.7c0-3.3 2.7-6 6-6s6 2.7 6 6s-3.9 7.7-6 9.7M12 6c-2.2 0-4 1.8-4 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2"
                />
              </svg>

              <span
                class="text-gray-600 text-xs font-medium break-words flex-1"
                [title]="getFullLocationNames(option.location)"
              >
                {{ getLocationNames(option.location) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!--  modal -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'open_modal_' + editID"
>
  <div
    (click)="$event.stopPropagation()"
    class="modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg shadow-lg bg-white dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="text-base font-semibold card-title">
        {{ !isWriteAccess ? "View Business Unit" : modalTitle }}
      </span>
    </div>
    <div class="modal-body gap-5 p-2">
      <app-modal-renderer
        *ngIf="activeModalContext"
        #modalRendererRef
        [nodeId]="activeModalContext?.nodeId"
        (header)="setModalTitle($event)"
        (closeModal)="closeModal('open_modal_' + editID)"
        (formSaved)="onModalFormSaved($event)"
        [recordIDs]="activeModalContext?.recordID"
        (formReady)="openCurrentModal()"
        [disableFields]="!isWriteAccess"
      ></app-modal-renderer>
    </div>
    <div
      *ngIf="!isWriteAccess"
      class="modal-footer p-4 flex justify-end border-t border-gray-100 dark:border-coal-700"
    >
      <button
        type="button"
        class="btn btn-sm btn-secondary cancel-modal-btn"
        (click)="closeModal('open_modal_' + editID)"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
